import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { SEASONS } from '../../../utils/constants';

const seasonKeys = ['spring', 'summer', 'autumn', 'winter'];

function SeasonsSection() {
  const [activeSeason, setActiveSeason] = useState('spring');
  
  const currentSeason = SEASONS && SEASONS[activeSeason] ? SEASONS[activeSeason] : null;

  if (!currentSeason) return null;

  return (
    <section id="seasons" className="py-24 relative overflow-hidden">
      <div className="container-custom relative z-10">
        {/* 🚀 優化：減少動畫時間 */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-50px" }}
          transition={{ duration: 0.5 }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 dark:text-white mb-4">
            Omakase 如何透過四季食材展現風味？
          </h2>
          <p className="text-lg text-slate-600 dark:text-slate-400 max-w-2xl mx-auto">
            隨著季節更迭，品味自然的饋贈
          </p>
        </motion.div>

        {/* Season Tabs */}
        <div className="flex justify-center gap-4 mb-12 flex-wrap">
          {seasonKeys.map((key) => {
            const season = SEASONS[key];
            return (
              <motion.button
                key={key}
                onClick={() => setActiveSeason(key)}
                className={`px-6 py-3 rounded-xl font-medium transition-all ${
                  activeSeason === key
                    ? `bg-gradient-to-r ${season.color} text-white shadow-lg`
                    : 'bg-white/60 dark:bg-slate-700/60 backdrop-blur-sm text-slate-700 dark:text-slate-300 hover:shadow-md'
                }`}
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                {season.name} {season.reading}
              </motion.button>
            );
          })}
        </div>

        {/* 🚀 優化：加快切換動畫 */}
        <AnimatePresence mode="wait">
          <motion.div
            key={activeSeason}
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            transition={{ duration: 0.3 }}
            className={`bg-gradient-to-br ${currentSeason.bgColor} rounded-3xl p-8 md:p-12 backdrop-blur-sm`}
          >
            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
              {currentSeason.ingredients.map((ingredient, index) => (
                <motion.div
                  key={ingredient.name}
                  initial={{ opacity: 0, scale: 0.95 }}
                  animate={{ opacity: 1, scale: 1 }}
                  transition={{ duration: 0.3, delay: index * 0.05 }}
                  className="card p-6 hover:shadow-xl transition-all"
                >
                  <h3 className="text-xl font-bold text-slate-900 dark:text-white mb-2">
                    {ingredient.name}
                  </h3>
                  <p className="text-sm text-slate-500 dark:text-slate-400 mb-3">
                    {ingredient.reading}
                  </p>
                  <p className="text-slate-600 dark:text-slate-300 text-sm leading-relaxed">
                    {ingredient.description}
                  </p>
                </motion.div>
              ))}
            </div>
          </motion.div>
        </AnimatePresence>
      </div>
    </section>
  );
}

export default SeasonsSection;